// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORM_IS_DIRTY_ARE_YOU_SURE_YOU_WANT_TO_LEAVE = "Ur\u010dite chce\u0161 od\u00eds\u0165? Pr\u00edde\u0161 o neulo\u017een\u00e9 zmeny.";
